// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3ALVC","savePackageButton":"ClientWallet_savePackageButton__18gUx"};